import { Select } from '@telus-uds/components-web'
import { useState, useEffect, useRef } from 'react'

export type SelectDropdownProps = {
  selectDropdownItems?: selectDropdownType[]
  localStorageKey?: string
  defaultValue?: string
}

export type selectDropdownType = {
  itemText: string
  itemValue: string
}

const SelectDropdown = ({ selectDropdownItems, localStorageKey, defaultValue }: SelectDropdownProps) => {
  const [selectedValue, setSelectedValue] = useState('')
  const localValueCurrent = useRef<string>(defaultValue)

  useEffect(() => {
    const localValue = localStorage.getItem(localStorageKey)

    localValueCurrent.current = localValue
  }, [localStorageKey, selectedValue])

  const handleSelect = (e) => {
    const value = e.target.value
    setSelectedValue(value)
    localStorage.setItem(localStorageKey, value)
    window.dispatchEvent(new Event('selectDropdownEvent'))
  }

  return (
    <div data-testid="selectDropdown">
      <Select
        onChange={() => handleSelect(event)}
        value={selectedValue === '' ? localValueCurrent.current : selectedValue}
      >
        {selectDropdownItems.map((selectDropdownItem, i) => {
          return (
            <Select.Item key={i} value={selectDropdownItem.itemValue}>
              {selectDropdownItem.itemText}
            </Select.Item>
          )
        })}
      </Select>
    </div>
  )
}

export default SelectDropdown
